import cx from 'classnames'
import PropTypes from 'prop-types'

import {COUNTER_POSITIONS, SLIDER_BASE_CLASS} from '../config.js'
import {counterPatternFactory} from '../utils.js'

const GalleryBasicCounter = ({currentSlide, images = [], counterPosition}) => {
  const numberOfImages = images.length
  const counterDisplay = counterPatternFactory({
    current: currentSlide + 1,
    total: numberOfImages
  })

  const position = COUNTER_POSITIONS[counterPosition]

  const baseClass = cx(`${SLIDER_BASE_CLASS}Counter ${SLIDER_BASE_CLASS}Counter--${position}`)

  return (
    <div className={baseClass}>
      <span className={`${SLIDER_BASE_CLASS}CounterText`}>{counterDisplay}</span>
    </div>
  )
}

GalleryBasicCounter.displayName = 'GalleryBasicCounter'
GalleryBasicCounter.propTypes = {
  counterPosition: PropTypes.oneOf(Object.values(COUNTER_POSITIONS)),
  currentSlide: PropTypes.number,
  images: PropTypes.array.isRequired
}

export default GalleryBasicCounter
